import { resolveSubtitleTabLabel } from '@/utils/subtitleLanguageLabel'

/** 预览字幕 Tab：关闭 */
export const SUBTITLE_OFF = 'off'

const OFF_OPTION = { value: SUBTITLE_OFF, label: '关闭' }

/** 预览接口 subtitles 列表 → Tab 选项 */
export function buildSubtitleOptions(subtitles) {
  const list = [OFF_OPTION]
  ;(subtitles || []).forEach((item) => {
    if (!item || !item.subtitleUrl) return
    const lang = item.language || item.subtitleUrl
    const label = resolveSubtitleTabLabel({
      language: lang,
      languageName: item.languageName
    })
    if (list.some((opt) => opt.value === lang)) return
    list.push({ value: lang, label })
  })
  return list
}

/** 从 Video.js 已加载的 HLS 内嵌字幕轨生成 Tab（不含「关闭」） */
export function buildSubtitleOptionsFromTextTracks(player) {
  const list = []
  if (!player || typeof player.textTracks !== 'function') return list
  const tracks = player.textTracks()
  for (let i = 0; i < tracks.length; i += 1) {
    const track = tracks[i]
    if (track.kind !== 'subtitles' && track.kind !== 'captions') continue
    const value = track.language || `track-${i}`
    if (list.some((item) => item.value === value)) continue
    const label = resolveSubtitleTabLabel({
      language: value,
      trackLabel: track.label
    })
    list.push({ value, label })
  }
  return list
}

/** 供 Video.js 挂载的字幕轨 */
export function buildVideoSubtitleTracks(subtitles) {
  return (subtitles || [])
    .filter((item) => item && item.subtitleUrl)
    .map((item, index) => {
      const language = item.language || `sub-${index}`
      const label =
        (item.languageName && String(item.languageName).trim()) ||
        language
      return {
        src: item.subtitleUrl,
        language,
        label
      }
    })
}

/** 剧集预览单集对象上的字幕字段（兼容多种后端命名） */
export function extractSubtitlesFromSeriesItem(seriesItem) {
  if (!seriesItem) return []
  const raw =
    seriesItem.subtitles ||
    seriesItem.subtitleList ||
    seriesItem.seriesSubtitleList ||
    []
  if (!Array.isArray(raw)) return []
  return raw
    .map((item) => {
      if (!item) return null
      const subtitleUrl =
        item.subtitleUrl || item.url || item.fileUrl || item.subtitleFileUrl || ''
      if (!subtitleUrl) return null
      return {
        language:
          item.language ||
          item.langCode ||
          item.langId ||
          item.languageCode ||
          '',
        languageName: item.languageName || item.langName || '',
        subtitleUrl: String(subtitleUrl).trim()
      }
    })
    .filter(Boolean)
}
